<template>
    <v-container>
        <h2 class="mb-4">{{ mode === 'create' ? 'Create User' : mode === 'edit' ? 'Edit User' : 'View User' }}</h2>
        <div v-if="mode && !['edit', 'create'].includes(mode)" class="edit-button-wrapper">
            <v-btn class="mx-2" dark medium color="primary" :loading="navigating" :disabled="navigating || submitting" @click="onEdit">
                <v-icon dark>mdi-account-edit</v-icon>
            </v-btn>
        </div>
        <v-form :readonly="readOnly">
            <v-text-field
                v-model="user.email"
                label="Email"
                :rules="rules"
                :clearable="clearable"
            />
            <v-text-field
                v-model="newPassword"
                :rules="rules"
                label="Password"
                :clearable="clearable"
            />
        </v-form>
        <div v-if="mode !== 'show'" class="submit-button-wrapper">
            <v-btn class="mx-2 white--text" large :loading="submitting" :disabled="shouldDisableSubmit() || submitting || navigating" color="primary" @click="onSubmit">
                Submit
            </v-btn>
        </div>
    </v-container>
</template>

<script>
    import userService from '@/services/user-service'

    export default {
        name: 'UserForm',
        data: () => {
            return {
                mode: null,
                readOnly: false,
                clearable: true,
                user: {
                    email: '',
                    password: ''
                },
                newPassword: '',
                userId: null,
                submitting: false,
                navigating: false,
                rules: [
                    v => !!v || 'Field is required'
                ]
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'create') {
                return
            } else if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            this.userId = this.$route.params.userId
            if (this.userId) {
                userService.getUserById(this.userId).then(resp => {
                    this.user.email = resp.data.user.email
                    this.user.partner = resp.data.user.partner
                })
            }
        },
        methods: {
            getItemText(item) {
                return `${item.firstName} ${item.lastName}`
            },
            async onSubmit() {
                this.submitting = true
                this.user.password = this.newPassword
                try {
                    if (this.mode === 'edit') {
                        await this.editUser()
                    } else if (this.mode === 'create') {
                        await this.createUser()
                    }
                } finally {
                    this.submitting = false
                }
            },
            async onEdit() {
                this.navigating = true
                try {
                    await this.$router.push(`/users/${this.userId}/edit`)
                } finally {
                    this.navigating = false
                }
            },
            async createUser() {
                const response = await userService.createUser(this.user)
                if (response.data.id) {
                    this.userId = response.data.id
                }
                this.$router.push(`/users`)
            },
            async editUser() {
                delete this.user.id
                await userService.editUserById(this.userId, this.user)
                this.$router.push(`/users`)
            },
            shouldDisableSubmit() {
                if (!this.validEmailForm(this.user.email) || this.newPassword === '') {
                    return true
                }
                return false
            },
            validEmailForm(email) {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return pattern.test(email)
            }
        }
    }
</script>

<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.description-label {
    color: rgba(0, 0, 0, 0.6);
}
.description-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.img-preview {
    max-width: 70%;
    margin: 0 auto;
}

.image-input {
    padding: 20px;
    width: 100%;
    border-style: groove;
    border: #D3D3D3 solid 2px;
    border-radius: 15px 50px;
    margin-top: 1vh;
}

.green-border {
    border-color: green;
}

.delete-btn {
    display: flex;
    justify-content: flex-end;
}
</style>

